import styled from 'styled-components';
import { ReactComponent as CameraIcon } from '../../../assets/icon_kamera.svg';
import { ReactComponent as RepeatIcon } from '../../../assets/icon_back.svg';
import { ReactComponent as MinusIcon } from '../../../assets/icon_minus.svg';
import { ReactComponent as PlusIcon } from '../../../assets/icon_plus.svg';
import { ReactComponent as FacebookIcon } from '../../../assets/icon_fb.svg';
import { ReactComponent as TwitterIcon } from '../../../assets/icon_twitter.svg';
import { ReactComponent as LinkedInIcon } from '../../../assets/icon_linkedin.svg';
import { ReactComponent as MailIcon } from '../../../assets/icon_mail.svg';


export const IconStyled = styled.div`
  svg {
    display: block;
  }
  polygon, path{
    ${props => `fill: ${props.theme.colors.iconColor}; `};
  }
`

const iconMap = {
  camera: CameraIcon,
  repeat: RepeatIcon,
  minus: MinusIcon,
  plus: PlusIcon,
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  linkedin: LinkedInIcon,
  mail: MailIcon,
}

const Icon = ({ id, color }) => {
  const Icon = iconMap[id];
  return <IconStyled>
    <Icon />
  </IconStyled>
}

export default Icon;
